module.exports = __webpack_public_path__ + "img/ai-tutorial-group-qrcode.e01a6e60.png";